import Actions from './actions';

const { open: openInNewTab } = Actions;

export { openInNewTab };

export { default as newTabMiddleware } from './middlewares/newTabMiddleware';
